import { useFormGroup } from "./useFormGroups.js";
import { useBindCx } from "@scalar/use-hooks/useBindCx";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, resolveDynamicComponent, unref, withCtx } from "vue";
var ScalarFormInputGroup_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarFormInputGroup",
	props: { is: { default: "div" } },
	setup(__props) {
		const { cx } = useBindCx();
		useFormGroup();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(resolveDynamicComponent(__props.is), normalizeProps(guardReactiveProps(unref(cx)("flex flex-col border rounded divide-y"))), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});
//#endregion
export { ScalarFormInputGroup_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarFormInputGroup.vue.script.js.map